enum BrandManagerIdentityProviders {
  Instagram = 'instagram',
  TikTok = 'tiktok',
  Pinterest = 'pinterest',
}

export { BrandManagerIdentityProviders }
